export default __webpack_public_path__ + "media/src/assets/images/report-1ce70fbc21f5b70a4967f1c96ee7cd5e.png";